import ContentCopy from '@mui/icons-material/ContentCopy';
import InfoIcon from '@mui/icons-material/Info';
import Warning from '@mui/icons-material/Warning';
import { IconButton, Tooltip, Typography } from '@mui/material';
import { action, computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import AutoComplete from '../AutoComplete';
import ReactComponent from '../ReactComponent';

class CodigoDecisao extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            registro: computed,
            decisoesProcessuais: computed,
            opcoesDecisoes: computed,
            opcoesDecisoesInvalidas: computed,
            callbackAutoCompleteDecisao: action,
            gravarDecisao: action,
            exibeAlertaDecisaoInativa: computed,
            certidaoJulgamentoTransferida: computed,
            descricaoDecisao: computed,
            handleCopyOpcoesDecisoes: action
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    get decisoesProcessuais() {
        return this.dominioStore.decisoesProcessuais;
    }

    get opcoesDecisoes() {
        return this.decisoesProcessuais ? this.converterOpcoesDecisao(this.decisoesProcessuais) : [];
    }

    get opcoesDecisoesInvalidas() {
        return this.opcoesDecisoes.filter((decisao) => decisao.selecionavel === false);
    }

    converterOpcoesDecisao = (decisoes) => {
        return decisoes.map((decisao) => {
            return {
                texto: decisao.id + ' - ' + decisao.descricao,
                valor: decisao.id.toString(),
                selecionavel: decisao.lancamentoManual
            };
        });
    };

    callbackAutoCompleteDecisao = (option) => {
        let valor = option ? option.valor : '';
        let texto = option ? option.texto.split(' - ')[1] : '';
        if (this.registro) {
            this.gravarDecisao(valor);
            this.registro.informacaoProcessoSalaSessao.decisao = {
                id: parseInt(valor),
                descricao: texto,
                ativo: true
            };
        } else if (this.observableProps.callbackDecisaoSelecionada) {
            this.observableProps.callbackDecisaoSelecionada(valor);
        }
    };

    gravarDecisao = async (idDecisao = '') => {
        if (this.isDecisaoAlterada(idDecisao)) {
            await this.processoService.gravarDecisao(
                this.registro.sessaoId,
                this.registro.numeroProcesso,
                idDecisao,
                this.sessaoStore.clienteEnvelopeId
            );
        }
    };

    isDecisaoAlterada(idDecisao) {
        return (
            (!this.registro.informacaoProcessoSalaSessao.decisao && idDecisao !== '') ||
            (this.registro.informacaoProcessoSalaSessao.decisao &&
                this.registro.informacaoProcessoSalaSessao.decisao.id !== idDecisao)
        );
    }

    get exibeAlertaDecisaoInativa() {
        return (
            this.registro &&
            this.registro.informacaoProcessoSalaSessao &&
            this.registro.informacaoProcessoSalaSessao.decisao &&
            this.registro.informacaoProcessoSalaSessao.decisao.id &&
            this.registro.informacaoProcessoSalaSessao.decisao.ativo === false
        );
    }

    get certidaoJulgamentoTransferida() {
        return this.registro && this.registro.certidaoJulgamentoTransferida;
    }

    get descricaoDecisao() {
        let descricao = null;
        if (this.registro && this.registro.informacaoProcessoSalaSessao.decisao) {
            if (this.registro.informacaoProcessoSalaSessao.decisao.descricao) {
                descricao =
                    this.registro.informacaoProcessoSalaSessao.decisao.id +
                    ' - ' +
                    this.registro.informacaoProcessoSalaSessao.decisao.descricao;
            } else if (this.registro.informacaoProcessoSalaSessao.decisao.id) {
                descricao = this.getDescricaoDecisao(this.registro.informacaoProcessoSalaSessao.decisao.id);
            }
        } else if (this.observableProps.idDecisao) {
            descricao = this.getDescricaoDecisao(this.observableProps.idDecisao);
        }
        return descricao;
    }

    getDescricaoDecisao(idDecisao) {
        let opcaoDecisao = this.opcoesDecisoes.find((opcao) => opcao.valor === idDecisao);
        return opcaoDecisao ? opcaoDecisao.texto : null;
    }

    handleCopyOpcoesDecisoes = () => {
        let textToCopy = '';
        if (this.registro && this.registro.informacaoProcessoSalaSessao.decisao && this.registro.informacaoProcessoSalaSessao.decisao.id) {
            textToCopy = this.registro.informacaoProcessoSalaSessao.decisao.id.toString();
        } else if (this.observableProps.idDecisao) {
            textToCopy = this.observableProps.idDecisao;
        }

        if (textToCopy) {
            navigator.clipboard.writeText(textToCopy);
            this.mensagemStore.abrirMensagemSucesso('Código de decisão copiado para a área de transferência');
        }
    };

    render() {
        return (
            <div style={{ display: 'flex', width: '100%', alignItems: 'center', margin: '3px 0px' }}>
                <Typography
                    variant="subtitle1"
                    color="primary"
                    style={{
                        display: 'flex',
                        flexGrow: 2,
                        marginLeft: '8px',
                        marginRight: '16px',
                        textAlign: 'center'
                    }}
                >
                    <b>{'Código de Decisão'}</b>
                </Typography>
                {this.certidaoJulgamentoTransferida ? (
                    <div style={{ display: 'flex', flexGrow: 100 }}>
                        <Typography variant="subtitle1">{this.descricaoDecisao || ''}</Typography>
                    </div>
                ) : (
                    <div
                        style={{ display: 'flex', flexGrow: 100, alignItems: 'center' }}
                        id="opcoesDecisoes"
                    >
                        <div>
                            {this.opcoesDecisoes && this.opcoesDecisoes.length > 0 && (
                                <IconButton
                                    onClick={this.handleCopyOpcoesDecisoes}
                                    size="large"
                                >
                                    <Tooltip title="Copiar Código de Decisão Selecionada">
                                        <ContentCopy />
                                    </Tooltip>
                                </IconButton>
                            )}
                        </div>
                        <div style={{ width: '100%' }}>
                            <AutoComplete
                                title={this.descricaoDecisao}
                                value={this.descricaoDecisao}
                                options={this.opcoesDecisoes}
                                onChange={this.callbackAutoCompleteDecisao}
                                getOptionDisabled={this.opcoesDecisoesInvalidas}
                                blurOnEnter
                            />
                        </div>

                        <div>
                            <IconButton
                                color="inherit"
                                aria-label="info"
                                style={{ width: '50px', cursor: 'default' }}
                                size="large"
                            >
                                <Tooltip
                                    title={
                                        'Alguns códigos de decisão estão desabilitados para evitar incoerências no sistema.'
                                    }
                                >
                                    <InfoIcon style={{ color: '#01579b' }} />
                                </Tooltip>
                            </IconButton>
                        </div>
                        {this.exibeAlertaDecisaoInativa === true && (
                            <Tooltip
                                placement="top"
                                title={
                                    'Código de decisão inativo: [' +
                                    this.registro.informacaoProcessoSalaSessao.decisao.id +
                                    '] ' +
                                    this.registro.informacaoProcessoSalaSessao.decisao.descricao +
                                    '.'
                                }
                            >
                                <Warning style={{ fill: 'darkorange' }} />
                            </Tooltip>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

export default inject('stores')(observer(CodigoDecisao));
